unit View.Cst.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCstEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcst_id: TLabel;
    edcst_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCstGet: TXDataWebClient;
    XDataClientCstDelete: TXDataWebClient;
    CstDataset: TXDataWebDataSet;
    CstDatasetcst_id: TStringField;
    CstDatasetnome: TStringField;
    CstDatasetexcluido: TBooleanField;
    CstDatasetinclusao: TDateTimeField;
    CstDatasetalteracao: TDateTimeField;
    CstDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCstGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCstDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCstDeleteError(Error: TXDataClientError);
    procedure CstDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCstEdit: TFViewCstEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCstEdit }

procedure TFViewCstEdit.btSaveClick(Sender: TObject);
begin
  if CstDataset.State in dsEditModes then
  begin
        CstDataset.Post;
    CstDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCstEdit.btDeleteClick(Sender: TObject);
begin
  if CstDataset.State in dsEditModes then
    CstDataset.Post;
  XDataClientCstDelete.Delete(CstDataset.EntitySetName,
    TJSObject(CstDataset.CurrentData));
end;


class function TFViewCstEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCstEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCstEdit.InsertEntity;
begin
  CstDataset.Close;
  CstDataset.SetJsonData('{}');
  CstDataset.Open;
  CstDataset.Insert;
end;

class function TFViewCstEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCstEdit(AForm).FInserting := AInserting;
    TFViewCstEdit(AForm).FId := AId;
    TFViewCstEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCstEdit(AForm).InsertEntity
    else
      TFViewCstEdit(AForm).LoadEntity;
    TFViewCstEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCstEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCstEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    CstDataset.Connection.Model.DefaultSchema.FindEntityType(
      CstDataset.EntitySetName
    )
  );
  XDataClientCstGet.Get(CstDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCstEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCstEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCstEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCstEdit.XDataClientCstGetLoad(Response: TXDataClientResponse);
begin
  CstDataset.Close;
  CstDataset.SetJsonData(Response.Result);
  CstDataset.Open;
  
  CstDataset.Edit;  
end;

procedure TFViewCstEdit.XDataClientCstDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCstEdit.XDataClientCstDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCstEdit.CstDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCstEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCstEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cst.form.message');
  lbMessage := TLabel.Create('view.cst.form.message.label');
  btCloseMessage := TButton.Create('view.cst.form.message.button');
  btCancel := TButton.Create('view.cst.form.btBack');
  btSave := TButton.Create('view.cst.form.btSave');
  btDelete := TButton.Create('view.cst.form.btDelete');
  lbcst_id := TLabel.Create('view.cst.form.lbcst_id');
  edcst_id := TDBEdit.Create('view.cst.form.edcst_id');
  lbnome := TLabel.Create('view.cst.form.lbnome');
  ednome := TDBEdit.Create('view.cst.form.ednome');
  lbexcluido := TLabel.Create('view.cst.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.cst.form.edexcluido');
  lbinclusao := TLabel.Create('view.cst.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.cst.form.edinclusao');
  lbalteracao := TLabel.Create('view.cst.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.cst.form.edalteracao');
  lbexclusao := TLabel.Create('view.cst.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.cst.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  CstDataset := TXDataWebDataSet.Create(Self);
  CstDatasetcst_id := TStringField.Create(Self);
  CstDatasetnome := TStringField.Create(Self);
  CstDatasetexcluido := TBooleanField.Create(Self);
  CstDatasetinclusao := TDateTimeField.Create(Self);
  CstDatasetalteracao := TDateTimeField.Create(Self);
  CstDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCstGet := TXDataWebClient.Create(Self);
  XDataClientCstDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcst_id.BeforeLoadDFMValues;
  edcst_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CstDataset.BeforeLoadDFMValues;
  CstDatasetcst_id.BeforeLoadDFMValues;
  CstDatasetnome.BeforeLoadDFMValues;
  CstDatasetexcluido.BeforeLoadDFMValues;
  CstDatasetinclusao.BeforeLoadDFMValues;
  CstDatasetalteracao.BeforeLoadDFMValues;
  CstDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCstGet.BeforeLoadDFMValues;
  XDataClientCstDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCstEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcst_id.SetParentComponent(Self);
    lbcst_id.Name := 'lbcst_id';
    lbcst_id.Left := 24;
    lbcst_id.Top := 192;
    lbcst_id.Width := 14;
    lbcst_id.Height := 13;
    lbcst_id.Caption := 'cst_id:';
    lbcst_id.Transparent := True;
    edcst_id.SetParentComponent(Self);
    edcst_id.Name := 'edcst_id';
    edcst_id.Left := 221;
    edcst_id.Top := 189;
    edcst_id.Width := 200;
    edcst_id.Height := 21;
    edcst_id.Enabled := True;
    edcst_id.TabOrder := 6;
    edcst_id.Text := 'edcst_id';
    edcst_id.DataField := 'cst_id';
    edcst_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := CstDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    CstDataset.SetParentComponent(Self);
    CstDataset.Name := 'CstDataset';
    CstDataset.AfterApplyUpdates := CstDatasetAfterApplyUpdates;
    CstDataset.EntitySetName := 'Cst';
    CstDataset.Connection := DMConnection.ApiConnection;
    CstDataset.Left := 176;
    CstDataset.Top := 8;
    CstDatasetcst_id.SetParentComponent(CstDataset);
    CstDatasetcst_id.Name := 'CstDatasetcst_id';
    CstDatasetcst_id.FieldName := 'cst_id';
    CstDatasetcst_id.Required := True;
    CstDatasetcst_id.Size := 255;
    CstDatasetnome.SetParentComponent(CstDataset);
    CstDatasetnome.Name := 'CstDatasetnome';
    CstDatasetnome.FieldName := 'nome';
    CstDatasetnome.Required := True;
    CstDatasetnome.Size := 255;
    CstDatasetexcluido.SetParentComponent(CstDataset);
    CstDatasetexcluido.Name := 'CstDatasetexcluido';
    CstDatasetexcluido.FieldName := 'excluido';
    CstDatasetexcluido.Required := False;
    CstDatasetinclusao.SetParentComponent(CstDataset);
    CstDatasetinclusao.Name := 'CstDatasetinclusao';
    CstDatasetinclusao.FieldName := 'inclusao';
    CstDatasetinclusao.Required := False;
    CstDatasetalteracao.SetParentComponent(CstDataset);
    CstDatasetalteracao.Name := 'CstDatasetalteracao';
    CstDatasetalteracao.FieldName := 'alteracao';
    CstDatasetalteracao.Required := False;
    CstDatasetexclusao.SetParentComponent(CstDataset);
    CstDatasetexclusao.Name := 'CstDatasetexclusao';
    CstDatasetexclusao.FieldName := 'exclusao';
    CstDatasetexclusao.Required := False;
    XDataClientCstGet.SetParentComponent(Self);
    XDataClientCstGet.Name := 'XDataClientCstGet';
    XDataClientCstGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCstGet, Self, 'OnLoad', 'XDataClientCstGetLoad');
    XDataClientCstGet.Left := 64;
    XDataClientCstGet.Top := 8;
    XDataClientCstDelete.SetParentComponent(Self);
    XDataClientCstDelete.Name := 'XDataClientCstDelete';
    XDataClientCstDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCstDelete, Self, 'OnLoad', 'XDataClientCstDeleteLoad');
    SetEvent(XDataClientCstDelete, Self, 'OnError', 'XDataClientCstDeleteError');
    XDataClientCstDelete.Left := 64;
    XDataClientCstDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcst_id.AfterLoadDFMValues;
    edcst_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CstDataset.AfterLoadDFMValues;
    CstDatasetcst_id.AfterLoadDFMValues;
    CstDatasetnome.AfterLoadDFMValues;
    CstDatasetexcluido.AfterLoadDFMValues;
    CstDatasetinclusao.AfterLoadDFMValues;
    CstDatasetalteracao.AfterLoadDFMValues;
    CstDatasetexclusao.AfterLoadDFMValues;
    XDataClientCstGet.AfterLoadDFMValues;
    XDataClientCstDelete.AfterLoadDFMValues;
  end;
end;

end.
